module.exports = __webpack_public_path__ + "../public/img/Qr_passo_2.618255ab.png";